// Woo Checkout – phone bridge (ACF Phone Number → altijd billing_phone posten)
let mounted = false;

function getCtx(root = document) {
  const field =
    root.querySelector('.acf-field[data-name="billing_phone"]') ||
    root.querySelector('.acf-field.wk-phone-input') ||
    null;

  // Zichtbare tel-input (ACFE of fallback)
  const tel =
    (field && field.querySelector('input[type="tel"]')) ||
    root.querySelector('input[name="billing_phone"]') ||
    null;

  // Verborgen ACF-waarde (ACFE bewaart vaak de canonieke waarde hierin)
  const acfHidden =
    (field && field.querySelector('input[type="hidden"][name^="acf["]')) ||
    null;

  const form = (tel && tel.form) || document.querySelector('form.checkout') || null;

  return { field, tel, acfHidden, form };
}

function ensureBridge(form) {
  if (!form) return null;
  let bridge = form.querySelector('input[name="billing_phone"][data-wk-bridge="1"]');
  if (!bridge) {
    bridge = document.createElement('input');
    bridge.type = 'hidden';
    bridge.name = 'billing_phone';
    bridge.setAttribute('data-wk-bridge', '1');
    form.appendChild(bridge);
  }
  return bridge;
}

function currentValue({ tel, acfHidden }) {
  const vHidden = acfHidden && (acfHidden.value || '').trim();
  const vTel    = tel && (tel.value || '').trim();
  // Geef verborgen ACFE-waarde (meestal E.164) voorrang als die "nummerachtig" oogt
  if (vHidden && /^\+?\d{6,}$/.test(vHidden)) return vHidden;
  return vTel || '';
}

function syncNow(root = document) {
  const ctx = getCtx(root);
  if (!ctx.form) return;
  const bridge = ensureBridge(ctx.form);
  if (!bridge) return;
  bridge.value = currentValue(ctx);
}

function bind(root = document) {
  const { tel, acfHidden, form } = getCtx(root);
  if (!form) return;

  ensureBridge(form);
  syncNow(root);

  const on = () => syncNow(root);

  [tel, acfHidden].forEach((el) => {
    if (!el || el.dataset.wkPhoneBound) return;
    el.dataset.wkPhoneBound = '1';
    ['input', 'change', 'blur'].forEach((ev) => el.addEventListener(ev, on));
  });

  // vóór Woo's serialisatie (jQuery event)
  if (window.jQuery) {
    const $ = window.jQuery;
    if (!form.dataset.wkPhonePlaceOrderBound) {
      form.dataset.wkPhonePlaceOrderBound = '1';
      $(document.body).on('checkout_place_order', () => { syncNow(root); });
    }
  }

  // Fallback: native submit (capture)
  if (!form.dataset.wkPhoneSubmitBound) {
    form.dataset.wkPhoneSubmitBound = '1';
    form.addEventListener('submit', () => syncNow(root), true);
  }
}

export function mount() {
  if (mounted) return;
  mounted = true;

  bind(document);

  // Woo her-renders
  ['updated_checkout', 'wc_fragment_refresh', 'updated_shipping_method']
    .forEach((evt) => document.body.addEventListener(evt, () => {
      bind(document);
      syncNow(document);
    }));

  // ACF (re)render
  if (window.jQuery) {
    window.jQuery(document).on('acf/ready acf/append', (_e, $el) => {
      const ctx = ($el && $el[0]) || document;
      bind(ctx);
      syncNow(ctx);
    });
  }
}

export default { mount };
